import React, { useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import './ModalImageViewer.css';

export default function ModalImageViewer({ src, alt, onClose }) {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="modal-overlay" onClick={onClose}>
       {!isLoaded && (
          <div className="modal-loading">
            <FaSpinner />
          </div>
        )}
      <div className="modal-content-installer" onClick={e => e.stopPropagation()}>       
        {isLoaded && (
          <>
            <div className="custom-modal-header" style={{ color: '#ccc' }}>
              <span className="custom-modal-title">Image Preview</span>
              <button className="custom-close-button" onClick={onClose}>✕</button>
            </div>
            <div className="custom-modal-body">
              <img src={src} alt={alt} />
            </div>
          </>
        )}
        <img
          src={src}
          alt={alt}
          style={{ display: 'none' }}
          onLoad={() => setIsLoaded(true)}
        />
      </div>
    </div>
  );
}
